//'use strict';
export default class TableChartPageController {

    constructor(
        futureCitiesService
    ) {

        let vm = this;

        vm.futureCitiesService = futureCitiesService;

        vm.pageTitle = 'Cities of the Future 2017';
        vm.orderByField = 'city';
        vm.reverseSort = false;
        vm.isInitSort = false;

        vm.futureCitiesService.sortBy = vm.orderByField;
        vm.tableData = vm.futureCitiesService.cityData;

        // vm.isInitSort=(field)=>{
        //     // console.log("---- ", field);
        //     if(vm.orderByField == 'city' && field == 'city') {
        //         console.log("----show ", field);
        //         return false;
        //     }else{
        //
        //         return true;
        //     }
        //
        // }

        vm.reportLinkSelected=(report)=>{
            ga('send', {
                hitType: 'event',
                eventCategory: 'VisApps',
                eventLabel: 'visapp-cities-future-2017',
                eventAction: 'visapp-cities-future-2017-city-report-clicked-' + report
            });


            ga('send', {
                hitType: 'screenview',
                appName: 'visapp-EC17-trends-quiz',
                screenName: 'visapp-cities-future-2017-city-report-clicked-' + report
            });

        }


        vm.isSortedField=(val)=>{
            if(val === vm.orderByField){
                return true;
            }else {
                return false;
            }
        }

        vm.getSortBy = () => {
            return vm.futureCitiesService.sortBy;
        }

        vm.setSortBy = (sortBy) => {
            vm.futureCitiesService.sortBy = sortBy;
            return vm.orderByField;
        }

        vm.getMaxValue = (metricName) =>{
            return vm.futureCitiesService.getMaxValue(metricName);
        }

    }
}

TableChartPageController.$inject = [
    'futureCitiesService'
];


// WEBPACK FOOTER //
// ./src/app/views/table-chart-page/table-chart-page.controller.js